"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationReadoutItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PaginationItemMixin = require("../../mixins/components/PaginationItemMixin");
/**
 * Used by the `Pagination` component to house the "Page x of x" label that appears on
 * smaller screens.
 *
 * @since 7.42.0
 */
var PaginationReadoutItem = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "PaginationReadoutItem",
  componentId: "c11n-8-101-0__sc-1dud86-0"
})(["", ""], _PaginationItemMixin.PaginationReadoutItemMixin);
exports.PaginationReadoutItem = PaginationReadoutItem;
PaginationReadoutItem.displayName = 'PaginationReadoutItem';

/** @component */